module.exports = __webpack_public_path__ + "img/intro-title.46e3f851.gif";